import { call, put, race, takeLatest, all } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import * as actionTypes from '../actionTypes/yotpo';
import config from 'config';
import apiClient from '../helpers/apiClient';

let _client = null;

function* getYotpoSiteRatings() {
    const successAction = { type: actionTypes.YOTPO_SITE_RATINGS_SUCCESS };
    const timeoutAction = { type: actionTypes.YOTPO_SITE_RATINGS_TIMEOUT };
    const errorAction = { type: actionTypes.YOTPO_SITE_RATINGS_FAILURE };
    try {
        const { data, timeout } = yield race({
            data: call(async () => _client.get(config.apiPath.yotpoSiteReview)),
            timeout: delay(2000)
        });
        if (data) {
            successAction.data = data;
            yield put(successAction);
        } else {
            timeoutAction.timeout = timeout;
            yield put(timeoutAction);
        }
    } catch (er) {
        errorAction.error = er;
        yield put(errorAction);
    }
}

export function* runYotpoCalls(client) {
    _client = client ? Object.assign({}, client) : apiClient();
    yield all([
        takeLatest(actionTypes.YOTPO_SITE_RATINGS_LOAD, getYotpoSiteRatings)
    ]);
}
